module.exports = __webpack_public_path__ + "img/BIH.b6f4acb5.svg";